export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nazwa: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wstecz"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proszę podać nową nazwę dla aktywa"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ta nazwa pomoże Ci łatwiej zidentyfikować portfel na liście aktywów."])}
}